import React, { Component } from 'react';
import * as $ from 'jquery';
import AssistantContainer from './assistant/AssistantContainer.js';
import ContactContainer from './contact/ContactContainer.js';
import Event from './events/Event.js';
import EventsContainer from './events/EventsContainer.js';
import HistoryContainer from './history/HistoryContainer.js';
import SDeliveryContainer from './sdelivery/SDeliveryContainer.js';
import InvoicePayment from './invoices/payment/ProsaPaymentContainer.js';
import InvoicesContainer from './invoices/InvoicesContainer.js';
import LocationsMap from './LocationsMap.js';
import Navbar from './Navbar';
import ProfileContainer from './profile/ProfileContainer.js';
import Promocode from './promocode/Promocode.js';
import Reservation from './history/Reservation.js';
import Service from './sdelivery/Service.js';
import Ticket from './tickets/Ticket.js';
import Room from './reservations/Room.js';
import RoomPayment from './reservations/payment/PaymentContainer.js';
import RoomPaymentContainer from './reservations/payment/RoomPaymentContainer.js';
import RoomsContainer from './reservations/RoomsContainer.js';
import RoomResevation from './reservations/RoomResevation.js';
import TicketsContainer from './tickets/TicketsContainer.js';
import { MENU, MENU_STATUS } from './Sidebar.js';
import { Redirect, Route, Switch } from 'react-router-dom';
import { translate } from 'react-i18next';
import InvoicePaymentStatus from './invoices/payment/ProsaPaymentStatusContainer.js';
import MarketplaceContainer from './marketplace/MarketplaceContainer.js';
import BenefitsContainer from './benefits/BenefitsContainer.js';
import Benefit from './benefits/Benefit.js';
import Profile from './mainPage/Profile.js';
import CoworkContainer from './cowork/CoworkContainer.js';
import ProfileUser from './profileUser/ProfileUser.js';
import ConecctionsContainer from './conecctions/ConecctionsContainer.js';
import MyConecctionsContainer from './myConecctions/MyConecctionsContainer';
import StoreContainer from './store/StoreContainer.js';
import RoomStore from './store/Reservation/Room.js';
import PaymentContainerStore from './store/Payment/PaymentContainer.js';
import ReservationContainer from './history/ReservationContainer.js';


let cancelToken;
let state;
let tokenSession;

class Dashboard extends Component {

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
    }
    this.state = state;
  }

  // componentDidMount() {
  //   $(window).resize(this.resize);
  //   this.resize();
  // }

  componentWillReceiveProps() {
    $('#wrapper')[0].scrollIntoView();
  }

  // componentWillUnmount() {
  //   $(window).off("resize", this.resize);
  // }

  getPermissionStatus = (itemId) => {
    const permissions = this.props.user.permissions;
    const itemStatus = permissions.filter((item) => item.id === itemId)[0];
    return itemStatus && itemStatus.status === MENU_STATUS.MESSAGE ? itemStatus.message : null;
  }

  isItemHidden = (itemId) => {
    const permissions = this.props.user.permissions;
    const itemStatus = permissions.filter((item) => item.id === itemId)[0];
    return itemStatus && itemStatus.status === MENU_STATUS.HIDE ? true : false;
  }

  isFunctionHidden = (itemId) => {
    const permissions = this.props.user.permissions;
    const itemStatus = permissions.filter((item) => item.id === itemId)[0];
    return itemStatus && itemStatus.status === MENU_STATUS.HIDE_FUNCTION ? true : false;
  }

  // resize = () => {
  //   $('#page-wrapper').css({
  //     paddingTop: this.props.getNavbarHeight()
  //   });
  // }

  renderAssistant = () => {
    if (!this.isItemHidden(MENU.ASSISTANT)) {
      return (
        <AssistantContainer
          getPermissionStatus={this.getPermissionStatus}
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post} />
      );
    }
  }

  renderContactContainer = () => {
    if (!this.isItemHidden(MENU.CONTACT)) {
      return (
        <ContactContainer
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  renderEvent = () => {
    if (!this.isItemHidden(MENU.EVENTS)) {
      return (
        <Event
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  renderEventsContainer = () => {
    if (!this.isItemHidden(MENU.EVENTS)) {
      return (
        <EventsContainer
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  renderHistoryContainer = () => {
    if (!this.isItemHidden(MENU.HISTORY)) {
      return (
        <HistoryContainer
          getPermissionStatus={this.getPermissionStatus}
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  renderSDeliveryContainer = () => {
    if (!this.isItemHidden(MENU.SDELIVERY)) {
      return (
        <SDeliveryContainer
          getPermissionStatus={this.getPermissionStatus}
          isFunctionHidden={this.isFunctionHidden}
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  renderInvoicePayment = () => {
    if (!this.isItemHidden(MENU.INVOICES)) {
      return (
        <InvoicePayment
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  renderInvoicePaymentStatus = () => {
    if (!this.isItemHidden(MENU.INVOICES)) {
      return (
        <InvoicePaymentStatus
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          post={this.props.post} />
      );
    }
  }

  renderInvoicesContainer = () => {
    if (!this.isItemHidden(MENU.INVOICES)) {
      return (
        <InvoicesContainer
          getPermissionStatus={this.getPermissionStatus}
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post} />
      );
    }
  }

  renderLocations = () => {
    if (!this.isItemHidden(MENU.LOCATIONS)) {
      return (
        <LocationsMap
          getNavbarHeight={this.props.getNavbarHeight} />
      );
    }
  }

  renderNavbar = () => {
    return (
      <Navbar
        getTokenId={this.props.getTokenId}
        getTokenSession={this.props.getTokenSession}
        handleErrorResponse={this.props.handleErrorResponse}
        handleLanguageChange={this.props.handleLanguageChange}
        handleLogoutClick={this.props.handleLogoutClick}
        handleUpdateSolicitudes={this.props.handleUpdateSolicitudes}
        lang={this.props.lang}
        post={this.props.post}
        setUser={this.props.setUser}
        user={this.props.user} />
    );
  }

  renderStoreContainer = () => {
    return (
      <StoreContainer
        getPermissionStatus={this.getPermissionStatus}
        getTokenId={this.props.getTokenId}
        getTokenSession={this.props.getTokenSession}
        handleErrorResponse={this.props.handleErrorResponse}
        post={this.props.post}
        user={this.props.user}
        setUser={this.props.setUser}
        postStore={this.props.postStore}
      />
    );
  }

  renderRoomContainerStore = () => {
    return (
      <RoomStore
        getPermissionStatus={this.getPermissionStatus}
        getTokenId={this.props.getTokenId}
        getTokenSession={this.props.getTokenSession}
        handleErrorResponse={this.props.handleErrorResponse}
        post={this.props.post}
        user={this.props.user}
        setUser={this.props.setUser}
        post_store={this.props.postStore}
      />
    )
  }

  renderPaymentContainerStore = () => {
    return (
      <PaymentContainerStore
        getPermissionStatus={this.getPermissionStatus}
        getTokenId={this.props.getTokenId}
        getTokenSession={this.props.getTokenSession}
        handleErrorResponse={this.props.handleErrorResponse}
        post={this.props.post}
        user={this.props.user}
        setUser={this.props.setUser}
        post_store={this.props.postStore}
      />
    )
  }

  renderPaymentContainerStore = () => {
    return (
      <CoworkContainer
        getTokenId={this.props.getTokenId}
        getTokenSession={this.props.getTokenSession}
        handleErrorResponse={this.props.handleErrorResponse}
        post={this.props.post}
        user={this.props.user}
      />
    )
  }

  renderPage = () => {
    if (!this.props.user.name || !this.props.user.lastname || this.props.user.ios_express === "1") {
      return this.renderModalData();
    }

    return (
      <div className='iosfera-portal'>
      <Switch>
        <Route exact path="/assistant" component={this.renderAssistant} />
        <Route exact path="/contact" component={this.renderContactContainer} />
        <Route exact path="/events" component={this.renderEventsContainer} />
        <Route exact path="/events/:eventid" component={this.renderEvent} />
        <Route exact path="/history" component={this.renderHistoryContainer} />
        <Route exact path="/history/:reservationid" component={this.renderReservation} />
        <Route exact path="/sdelivery" component={this.renderSDeliveryContainer} />
        <Route exact path="/sdelivery/:sdeliveryid" component={this.renderService} />
        <Route exact path="/invoices" component={this.renderInvoicesContainer} />
        <Route exact path="/invoices/payment" component={this.renderInvoicePayment} />
        <Route exact path="/locations" component={this.renderLocations} />
        <Route exact path="/user/:userid" component={this.ProfileUser} />
        <Route exact path="/profile" component={this.renderProfile} />
        <Route exact path="/profile/myconnections" component={this.MyConecctionsContainer} />
        <Route exact path="/profile/edit/user" component={this.renderProfileContainer} />
        <Route exact path="/profile/edit/facturacion" component={this.renderProfileContainer} />
        <Route exact path="/profile/edit/contact" component={this.renderProfileContainer} />
        <Route exact path="/iosconection" component={this.ConecctionsContainer} />
        <Route exact path="/promocode" component={this.renderPromocode} />
        <Route exact path="/reservations" component={this.renderRoomsContainer} />
        <Route exact path="/reservations/:reservationid" component={this.renderRoom} />
        <Route exact path="/reservations/:reservationid/payment" component={this.renderRoomPayment} />
        <Route exact path="/reservation/:reservationid/" component={this.renderReservationRoom} />
        <Route exact path="/reservation/:reservationid/payment" component={this.RoomPaymentContainer} />
        <Route exact path="/tickets" component={this.renderTicketsContainer} />
        <Route exact path="/ticket/:ticketid" component={this.renderTicket} />
        <Route exact path="/invoices/payment/status" component={this.renderInvoicePaymentStatus} />
        <Route exact path="/marketplace" component={this.renderMarketplaceContainer} />
        <Route exact path="/benefit" component={this.BenefitsContainer} />
        <Route exact path="/cowork" component={this.renderPaymentContainerStore} />
        <Route exact path="/benefit/:benefitid" component={this.renderBenfit} />

        {/* Se comentan todo referente a la version anterior de Venta en Línea */}
        {/* <Route exact path="/store_invitado" component={this.renderStoreContainer} />
        <Route exact path="/store_invitado/room/" component={this.renderRoomContainer} />
        <Route exact path="/store_invitado/room/:roomid" component={this.renderRoomContainerStore} />
        <Route exact path="/store_invitado/room/:roomid/:reservationsid" component={this.renderRoomContainerStore} />
        <Route exact path="/store_invitado/book/:reservationsid" component={this.renderPaymentContainerStore} /> */}
        <Route path="/" component={() => <Redirect to="/marketplace" />} />
      </Switch>
      </div>
    )
  }


  renderProfileContainer = () => {
    if (!this.isItemHidden(MENU.PROFILE)) {
      return (
        <ProfileContainer
          getPermissionStatus={this.getPermissionStatus}
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          setUser={this.props.setUser}
          user={this.props.user} />
      );
    }
  }

  renderReservation = () => {
    if (!this.isItemHidden(MENU.HISTORY)) {
      return (
        <ReservationContainer
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user}
        />
      );
    }
  }

  renderService = () => {
    if (!this.isItemHidden(MENU.SDELIVERY)) {
      return (
        <Service
          getPermissionStatus={this.getPermissionStatus}
          isFunctionHidden={this.isFunctionHidden}
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  renderTicket = () => {
    if (!this.isItemHidden(MENU.TICKETS)) {
      return (
        <Ticket
          getPermissionStatus={this.getPermissionStatus}
          isFunctionHidden={this.isFunctionHidden}
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }


  renderRoomPayment = () => {
    if (!this.isItemHidden(MENU.RESERVATIONS)) {
      return (
        <RoomPayment
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  renderRoomsContainer = () => {
    if (!this.isItemHidden(MENU.RESERVATIONS)) {
      return (
        <RoomsContainer
          getPermissionStatus={this.getPermissionStatus}
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user}
          setUser={this.props.setUser} />
      );
    }
  }

  renderTicketsContainer = () => {
    if (!this.isItemHidden(MENU.TICKETS)) {
      return (
        <TicketsContainer
          getPermissionStatus={this.getPermissionStatus}
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          user={this.props.user}
          post={this.props.post} />
      );
    }
  }

  renderPromocode = () => {
    if (!this.isItemHidden(MENU.PROMOCODE)) {
      return (
        <Promocode
          getPermissionStatus={this.getPermissionStatus}
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          setUser={this.props.setUser}
          user={this.props.user} />
      );
    }
  }

  renderMarketplaceContainer = () => {
    if (!this.isItemHidden(MENU.MARKETPLACE)) {
      return (
        <MarketplaceContainer
          getPermissionStatus={this.getPermissionStatus}
          isFunctionHidden={this.isFunctionHidden}
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  render() {
    if (!this.props.user) {
      return <Redirect to="/onboarding" />;
    } else if (!this.props.user.permissions) {
      this.props.handleLogoutClick();
      return <Redirect to="/onboarding" />;
    }

    return (
      <div id="wrapper">
        {this.renderNavbar()}
        <div id="page-wrapper">
          <div>
            {this.renderPage()}
          </div>
        </div>
      </div>
    );
  }

  renderModalData = () => {
    return (
      <ProfileContainer
        getPermissionStatus={this.getPermissionStatus}
        getTokenId={this.props.getTokenId}
        getTokenSession={this.props.getTokenSession}
        handleErrorResponse={this.props.handleErrorResponse}
        post={this.props.post}
        setUser={this.props.setUser}
        user={this.props.user} />
    );
  }

  BenefitsContainer = () => {
    if (!this.isItemHidden(MENU.MARKETPLACE)) {
      return (
        <BenefitsContainer
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  renderBenfit = () => {
    if (!this.isItemHidden(MENU.MARKETPLACE)) {
      return (
        <Benefit
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  renderProfile = () => {
    return (
      <Profile
        getTokenId={this.props.getTokenId}
        getTokenSession={this.props.getTokenSession}
        handleErrorResponse={this.props.handleErrorResponse}
        post={this.props.post}
        user={this.props.user} />
    );
  }

  renderRoom = () => {
    if (!this.isItemHidden(MENU.RESERVATIONS)) {
      return (
        <Room
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  renderReservationRoom = () => {
    if (!this.isItemHidden(MENU.RESERVATIONS)) {
      return (
        <RoomResevation
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  RoomPaymentContainer = () => {
    if (!this.isItemHidden(MENU.RESERVATIONS)) {
      return (
        <RoomPaymentContainer
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  ProfileUser = () => {
    if (!this.isItemHidden(MENU.RESERVATIONS)) {
      return (
        <ProfileUser
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  MyConecctionsContainer = () => {
    if (!this.isItemHidden(MENU.MARKETPLACE)) {
      return (
        <MyConecctionsContainer
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }

  ConecctionsContainer = () => {
    if (!this.isItemHidden(MENU.MARKETPLACE)) {
      return (
        <ConecctionsContainer
          getTokenId={this.props.getTokenId}
          getTokenSession={this.props.getTokenSession}
          handleErrorResponse={this.props.handleErrorResponse}
          post={this.props.post}
          user={this.props.user} />
      );
    }
  }
}

export default translate('common')(Dashboard);



// WEBPACK FOOTER //
// ./src/dashboard/Dashboard.js